import { api } from "../../App/services/api";
// ─── API Calls ───────────────────────────────────────────
function getSmtpSetting() {
    return api.get("/smtp");
}
function saveSmtpSetting(config) {
    return api.post("/smtp", config);
}
function changeSmtpStatus(active) {
    return api.post("/smtp/change-status", { active: active });
}
export default { getSmtpSetting: getSmtpSetting, saveSmtpSetting: saveSmtpSetting, changeSmtpStatus: changeSmtpStatus };
